// extracted by mini-css-extract-plugin
export var close = "index-module--close--uNdQc";
export var container = "index-module--container--nXS8x";
export var right = "index-module--right--LXWns";
export var slideContent = "index-module--slide-content---CFRV";
export var slideInfo = "index-module--slide-info--a66sz";
export var stageText = "index-module--stage-text--fpncK";
export var stepTitle = "index-module--stepTitle--MGNOI";
export var toggleA = "index-module--toggleA--Mmku9";
export var toggleB = "index-module--toggleB--1vWok";